var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid px-4",attrs:{"id":"app"}},[(_vm.user_loaded)?_c('PageLayout',{attrs:{"msg":"Connect Boxes"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }